import React from "react";
import { useState } from "react";
import Validation from "../../../../Helper/validations/vaildation";
import hospitalController from "../../../../../apis/Controllers/HospitalController/hospital.controller";
import { actionsController } from "../../../../../apis/Controllers/CommonController/action.controller";

const AddStafFunction = () => {
    const defaultValues = {
        hospital: "",
        name: "",
        email: "",
        phoneNo: "",
        employeeId: "",
        role: "",
        gender: "",
        bloodGroup: "",
        dob: "",
        joiningDate: "",
        department: "",
        specialization: "",
        state: "",
        city: "",
        address: "",
    };
    const defaultErrors = {
        hospital: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        name: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        email: {
            rules: ["required", "email"],
            isValid: true,
            message: "",
        },
        phoneNo: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        role: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        employeeId: {
            rules: ["required", "alphanumeric"],
            isValid: true,
            message: "",
        },
        gender: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        bloodGroup: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        dob: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        joiningDate: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        department: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        specialization: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        state: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        city: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        address: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
    };

    const [values, setValues] = useState(defaultValues);
    const [isError, setError] = useState(defaultErrors);
    const [loader, setLoader] = useState(false);
    const [hospitalsListing, setHospitalsListing] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [genderList, setGenderList] = useState([]);
    const [bloodgrpList, setBloodgrpList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);

    const handleChange = (field, value) => {
        let validation = new Validation(isError);
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        setValues({ ...values, [field]: value });
    };

    const getHospitalListing = async (e, page) => {
        if (!loader) {
            let post = {
                search: e ? e : "",
                page: page ? page : 1,
            };
            setLoader(true);
            let response = await hospitalController.hospitalListing(post);
            if (response && response.status) {
                let array1 = response.data;
                for (let i in array1) {
                    array1[i]["label"] = array1[i].title;
                }
                setHospitalsListing(array1);

                let array = response.data.departments;
                for (let i in array) {
                    array[i]["label"] = array[i].title;
                }
                setDepartmentList(array);
                setLoader(false);
            } else {
                setHospitalsListing([]);
                setLoader(false);
            }
            setLoader(false);
        }
    };

    const getbloodGroup = async () => {
        let response = await actionsController.bloodGroups(null);
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setBloodgrpList(array);
        } else {
            setBloodgrpList([]);
        }
    };

    const getcities = async () => {
        let response = await actionsController.citiesList(null);
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setCitiesList(array);
        } else {
            setCitiesList([]);
        }
    };

    const getstate = async () => {
        let response = await actionsController.statesList(null);
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setStateList(array);
        } else {
            setStateList([]);
        }
    };
    const getGender = async () => {
        let response = await actionsController.gendersList(null);
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setGenderList(array);
        } else {
            setGenderList([]);
        }
    };

    console.log(values && values, "<-----values-----");
    // console.log(genderList, "<=======response======");
    // console.log(hospitalsListing, "------hospitallisting-----");

    return {
        values,
        setValues,
        isError,
        loader,
        handleChange,
        getHospitalListing,
        hospitalsListing,
        getcities,
        citiesList,
        getstate,
        stateList,
        getGender,
        genderList,
        getbloodGroup,
        bloodgrpList,
        departmentList,
    };
};

export default AddStafFunction;
